import { BASIC_TAX_RATE, PERSONAL_ALLOWANCE_TAX } from './constants';

export const roundCurrency = (value: number) => Math.floor((value + Number.EPSILON) * 100) / 100;

export const formatToGBP = (value: string | number | null) => {
    if (value === 0) return '£0';
    if (!value) return '';

    let numericValue = value;

    if (typeof value === 'string') {
        numericValue = parseFloat(value);
        if (isNaN(numericValue)) return '';
    }

    numericValue = roundCurrency(numericValue as number);

    const formattedValue = numericValue.toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    return formattedValue;
};

export const grossUp = (amount: number): number => {
    if (amount <= PERSONAL_ALLOWANCE_TAX) {
        return amount;
    }

    const afterAllowance = amount - PERSONAL_ALLOWANCE_TAX;
    const grossTaxable = Math.floor(afterAllowance / (1 - BASIC_TAX_RATE));
    return PERSONAL_ALLOWANCE_TAX + grossTaxable;
};
